export const extractVideoCover = (videoFile) => {
  return new Promise((resolve, reject) => {
    const videoElement = document.createElement('video');
    const canvasElement = document.createElement('canvas');
    const fileReader = new FileReader();

    fileReader.onload = function (event) {
      videoElement.src = event.target.result;
    };

    videoElement.onloadedmetadata = function () {
      videoElement.currentTime = 0; // Capture the first frame
    };

    videoElement.onseeked = function () {
      // Set the canvas size to the video dimensions
      canvasElement.width = videoElement.videoWidth;
      canvasElement.height = videoElement.videoHeight;

      const context = canvasElement.getContext('2d');
      context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);

      // Convert canvas to Blob
      canvasElement.toBlob((blob) => {
        if (blob) {
          const coverImageFile = new File([blob], 'cover.png', { type: 'image/png' });
          resolve(coverImageFile);
        } else {
          reject(new Error('Failed to create blob from canvas'));
        }
      }, 'image/png');
    };

    videoElement.onerror = function () {
      reject(new Error('Failed to load video file. It might be due to a file format issue.'));
    };

    fileReader.onerror = function () {
      reject(new Error('Failed to read the video file.'));
    };

    // Read the video file as a data URL
    fileReader.readAsDataURL(videoFile);
  });
};
